<template>
    <select v-model="selectedValue" @change="updateInput">
        <option value="zz" :label="$t('country_code.other')">{{ $t('country_code.other') }}</option>
        <option
            v-for="(country, index) in countries"
            :key="index"
            :label="$t(`country_code.${index}`)"
            :value="index"
        >
            {{ $t(`country_code.${index}`) }}
        </option>
    </select>
</template>

<script>
import countries from '@/data/countries';

export default {
    name: 'country-select',
    props: {
        preselectedValue: {
            type: [String, null],
            default: '',
        },
    },
    data() {
        return {
            countries: countries,
            selectedValue: '',
        };
    },
    watch: {
        preselectedValue: {
            handler() {
                this.selectedValue =
                    this.preselectedValue && this.preselectedValue.length > 0
                        ? this.preselectedValue
                        : null;
            },
        },
    },
    mounted() {
        this.selectedValue =
            this.preselectedValue && this.preselectedValue.length > 0
                ? this.preselectedValue
                : null;
    },
    methods: {
        updateInput() {
            setTimeout(() => {
                this.$emit('input', this.selectedValue);
            }, 100);
        },
    },
};
</script>
